export default {
  label: 'Tags',
  placeholder: 'Select tags',
  helper: 'Select a tag or create a new one',
  create: 'Create "{value}"'
}
